// Badge minimal — dot + texto neutro — variando a cor do dot conforme status.
// Segue DESIGN_SYSTEM §componentes/Badges: NUNCA fundo colorido sólido,
// dot + halo soft + texto em ink-2.

import type { ClientStatus } from '@control-center/shared';

import { cn } from '@control-center/ui';

interface ClientStatusBadgeProps {
  status: ClientStatus;
  className?: string;
}

const STATUS_LABEL: Record<ClientStatus, string> = {
  lead: 'Lead',
  ativo: 'Ativo',
  em_implantacao: 'Em implantação',
  em_teste: 'Em teste',
  inadimplente: 'Inadimplente',
  suspenso: 'Suspenso',
  cancelado: 'Cancelado',
  merged: 'Mesclado',
  pending_link: 'Aguardando link',
};

const STATUS_TONE: Record<ClientStatus, 'good' | 'warn' | 'bad' | 'mute' | 'info'> = {
  lead: 'info',
  ativo: 'good',
  em_implantacao: 'info',
  em_teste: 'info',
  inadimplente: 'warn',
  suspenso: 'warn',
  cancelado: 'bad',
  merged: 'mute',
  pending_link: 'mute',
};

const TONE_DOT: Record<'good' | 'warn' | 'bad' | 'mute' | 'info', string> = {
  good: 'bg-good shadow-[0_0_0_3px_rgba(34,197,94,0.18)]',
  warn: 'bg-warn shadow-[0_0_0_3px_rgba(202,138,4,0.18)]',
  bad: 'bg-bad shadow-[0_0_0_3px_rgba(239,68,68,0.18)]',
  mute: 'bg-muted-2 shadow-[0_0_0_3px_rgba(113,113,122,0.18)]',
  info: 'bg-ink shadow-[0_0_0_3px_rgba(250,250,250,0.10)]',
};

export function ClientStatusBadge({ status, className }: ClientStatusBadgeProps): JSX.Element {
  const tone = STATUS_TONE[status];
  return (
    <span
      className={cn('inline-flex items-center gap-2 text-[12px] font-medium text-ink-2', className)}
    >
      <span className={cn('h-[6px] w-[6px] shrink-0 rounded-full', TONE_DOT[tone])} />
      {STATUS_LABEL[status]}
    </span>
  );
}
